import { useState, useEffect, useRef } from "react";
import SearchIcon from "../../../assets/searchIcon.svg";
import FileDownloadOutlinedIcon from "@mui/icons-material/FileDownloadOutlined";
import RefreshIcon from "@mui/icons-material/Refresh";
import { CircularProgress } from "@mui/material";
import { ReportServices } from "../../../services/ReportServices";
import { handleApiErrorResponses } from "../../../utils/ApisErrorHandling";
import { getUser } from "../../../config/user";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";
import * as XLSX from "xlsx";
import HospitalCustomPaginaion from "../../../utils/HospitalPaginationUtil";
import { toast } from "react-toastify";
import { filter } from "jszip";
import MonthRangeDropdown from "./MonthRangeDropDown";
const RevenueReport = () => {
  const [reportData, setReportData] = useState([]);
  const [filteredReportData, setFilteredReportData] = useState([]);
  const [paginatedData, setPaginatedData] = useState([]);
  const [monthlyCountData, setMonthlyCountData] = useState();
  const [allReportData, setAllReportData] = useState([]);
  const [erroneousReportData, setErroneousReportData] = useState([]);
  const [reprocessReportData, setReprocessReportData] = useState([]);
  const [stageType, setStageType] = useState("all");
  const [caseType, setCaseType] = useState("");
  const [caseStage, setCaseStage] = useState("");
  const [filterStage, setFilterStage] = useState("Request Admission Initiated");
  const [subStageType, setSubStageType] = useState("");
  const [claimType, setClaimType] = useState("");

  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [limit, setLimit] = useState(10);
  const [value, setValue] = useState(10);

  // New: year/month selection
  const [selectedYear, setSelectedYear] = useState("");
  const [selectedMonth, setSelectedMonth] = useState(""); // "01".."12"

  // Internal start/end dates actually sent to API
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);

  const [loading, setLoading] = useState(false);
  const [showDownloadMenu, setShowDownloadMenu] = useState(false);
  const [searchKey, setSearchKey] = useState("");

  const user = getUser();
  const searchTimeRef = useRef();

  const handleSearch = (e) => {
    if (searchTimeRef.current) clearInterval(searchTimeRef.current);
    searchTimeRef.current = setTimeout(
      () => setSearchKey(e.target.value.trim()),
      500,
    );
    setPage(1);
  };

  const getMonthlyReportCount = async () => {
    setLoading(true);
    try {
      const res = await ReportServices?.getHsaMonthlyClaimReportCount(
        user?.hospital?.id,
      );

      console.log("report data count:", res?.data);
      setMonthlyCountData(res?.data);
    } catch (error) {
      handleApiErrorResponses(error);
    }
    setLoading(false);
  };
  const getMonthlyReport = async () => {
    if (!startDate || !endDate) return;

    setLoading(true);

    try {
      let finalData = [];

      if (claimType === "") {
        const allResponse = await ReportServices?.getHsaMonthlyClaimReport(
          startDate,
          endDate,
          user?.hospital?.id,
          "",
        );

        const allData = allResponse?.data?.monthlyCaseReport || [];

        setAllReportData(allData);

        // 2. Erroneous response
        const erroneousResponse =
          await ReportServices?.getHsaMonthlyClaimReport(
            startDate,
            endDate,
            user?.hospital?.id,
            "erroneousClaim",
          );

        const erroneousData = erroneousResponse?.data?.monthlyCaseReport || [];

        setErroneousReportData(erroneousData);

        // 3. Reprocess response
        const reprocessResponse =
          await ReportServices?.getHsaMonthlyClaimReport(
            startDate,
            endDate,
            user?.hospital?.id,
            "reprocessClaim",
          );

        const reprocessData = reprocessResponse?.data?.monthlyCaseReport || [];

        setReprocessReportData(reprocessData);

        if (erroneousData.length === 0 && reprocessData.length === 0) {
          finalData = allData;
        } else {
          finalData = [...allData, ...erroneousData, ...reprocessData];
        }
      } else if (claimType === "erroneousClaim") {
        const response = await ReportServices?.getHsaMonthlyClaimReport(
          startDate,
          endDate,
          user?.hospital?.id,
          "erroneousClaim",
        );

        finalData = response?.data?.monthlyCaseReport || [];

        setErroneousReportData(finalData);
      } else if (claimType === "reprocessClaim") {
        const response = await ReportServices?.getHsaMonthlyClaimReport(
          startDate,
          endDate,
          user?.hospital?.id,
          "reprocessClaim",
        );

        finalData = response?.data?.monthlyCaseReport || [];

        setReprocessReportData(finalData);
      } else if (claimType === "claimReceived") {
        const response = await ReportServices?.getHsaMonthlyClaimReport(
          startDate,
          endDate,
          user?.hospital?.id,
          "claimReceived",
        );

        finalData = response?.data?.monthlyCaseReport || [];
      }

      setReportData(finalData);
      setFilteredReportData(finalData);
      setPage(1);

      const sliced = finalData.slice(0, limit);
      setPaginatedData(sliced);
    } catch (error) {
      handleApiErrorResponses(error);
    } finally {
      setLoading(false);
    }
  };
  const handleRefresh = async () => {
    setLoading(true);

    try {
      const countResponse = await ReportServices?.getHsaMonthlyClaimReportCount(
        user?.hospital?.id,
      );

      setMonthlyCountData(countResponse?.data);

      await getMonthlyReport();
    } catch (error) {
      handleApiErrorResponses(error);
    } finally {
      setLoading(false);
    }
  };

  const generatePdf = (caseData) => {
    const doc = new jsPDF("landscape");

    const formatDate = (date) =>
      date
        ? new Date(date).toLocaleString("en-GB", {
            day: "2-digit",
            month: "2-digit",
            year: "numeric",
            hour: "2-digit",
            minute: "2-digit",
            second: "2-digit",
            hour12: false,
          })
        : "NA";

    const headers = [
      "SNo.",
      "Patient Name",
      "Beneficiary ID",
      "Registered ID",
      "Registered Date",
      "Claim Initiated",

      ...(claimType !== "reprocessClaim" ? ["Claim Approved"] : []),

      ...(claimType === "" ? ["TDS", "Revenue Credited"] : []),

      ...(claimType !== "reprocessClaim" ? ["Erroneous Requested"] : []),
    ];

    const rows = caseData.map((item, index) => {
      const row = [
        index + 1,
        item.patientName || "NA",
        item.beneficiaryNo || "NA",
        item.pmjayRegistrationId || "NA",
        formatDate(item.registeredDate),

        claimType === "reprocessClaim"
          ? item?.reprocessClaimDetails?.claimSubmittedAmount || "NA"
          : claimType === "erroneousClaim"
            ? item?.erroneousClaimDetails?.claimSubmittedAmount || "NA"
            : item?.claimDetails?.claimInitiatedAmount || "NA",
      ];

      if (claimType !== "reprocessClaim") {
        row.push(
          claimType === "erroneousClaim"
            ? item?.erroneousClaimDetails?.claimApprovedAmount || "NA"
            : item?.claimDetails?.claimApprovedAmount || "NA",
        );
      }

      if (claimType === "") {
        row.push(
          item?.claimDetails?.tdsAmount || "NA",
          item?.claimDetails?.claimPaidAmount || "NA",
        );
      }

      if (claimType !== "reprocessClaim") {
        row.push(item?.erroneousClaimDetails?.erroneousRequestedAmount || "NA");
      }

      return row;
    });
    autoTable(doc, {
      head: [[...headers]],
      body: rows,
      styles: { fontSize: 8, cellPadding: 3 },
      headStyles: {
        fillColor: [230, 230, 230],
        textColor: [0, 0, 0],
      },
      startY: 20,
    });

    doc.save("case_report.pdf");
  };

  const generateExcel = (caseData) => {
    if (!caseData?.length) {
      toast.info("No data present to generate excel.");
      return;
    }

    try {
      const formatDate = (date) =>
        date
          ? new Date(date).toLocaleString("en-GB", {
              day: "2-digit",
              month: "2-digit",
              year: "numeric",
              hour: "2-digit",
              minute: "2-digit",
              second: "2-digit",
              hour12: false,
            })
          : "NA";

      const excelData = caseData.map((item, index) => {
        const row = {
          "SNo.": index + 1,
          "Patient Name": item?.patientName || "NA",
          "Beneficiary ID": item?.beneficiaryNo || "NA",
          "Registered ID": item?.pmjayRegistrationId || "NA",
          "Registered Date": formatDate(item?.registeredDate),

          "Claim Initiated":
            claimType === "reprocessClaim"
              ? item?.reprocessClaimDetails?.claimSubmittedAmount || "NA"
              : claimType === "erroneousClaim"
                ? item?.erroneousClaimDetails?.claimSubmittedAmount || "NA"
                : item?.claimDetails?.claimInitiatedAmount || "NA",
        };

        if (claimType !== "reprocessClaim") {
          row["Claim Approved"] =
            claimType === "erroneousClaim"
              ? item?.erroneousClaimDetails?.claimApprovedAmount || "NA"
              : item?.claimDetails?.claimApprovedAmount || "NA";
        }

        if (claimType === "") {
          row["TDS"] = item?.claimDetails?.tdsAmount || "NA";
          row["Revenue Credited"] = item?.claimDetails?.claimPaidAmount || "NA";
        }

        if (claimType !== "reprocessClaim") {
          row["Erroneous Requested"] =
            item?.erroneousClaimDetails?.erroneousRequestedAmount || "NA";
        }

        return row;
      });

      const worksheet = XLSX.utils.json_to_sheet(excelData);

      worksheet["!cols"] =
        claimType === "reprocessClaim"
          ? [{ wch: 8 }, { wch: 25 }, { wch: 22 }, { wch: 22 }, { wch: 20 }]
          : claimType === "erroneousClaim"
            ? [
                { wch: 8 },
                { wch: 25 },
                { wch: 22 },
                { wch: 22 },
                { wch: 20 },
                { wch: 20 },
                { wch: 22 },
              ]
            : [
                { wch: 8 },
                { wch: 25 },
                { wch: 22 },
                { wch: 22 },
                { wch: 20 },
                { wch: 20 },
                { wch: 15 },
                { wch: 22 },
                { wch: 22 },
              ];

      const workbook = XLSX.utils.book_new();

      XLSX.utils.book_append_sheet(workbook, worksheet, "Revenue Report");

      XLSX.writeFile(workbook, "revenue-credited-report.xlsx");
    } catch (error) {
      console.error("Excel download error:", error);
      handleApiErrorResponses(error);
    }
  };
  useEffect(() => {
    if (searchKey === "" || searchKey === null) {
      const startIndex = 0;
      setFilteredReportData(reportData);
      const sliced = reportData.slice(startIndex, startIndex + limit);
      setPaginatedData(sliced);
    } else {
      const modifiedData = reportData?.filter((data) =>
        data?.patientName?.toLowerCase()?.includes(searchKey?.toLowerCase()),
      );
      const modifiedData2 = reportData?.filter(
        (data) =>
          data?.pmjayRegistrationId
            ?.toLowerCase()
            ?.includes(searchKey?.toLowerCase()) ||
          data.beneficiaryNo?.toLowerCase()?.includes(searchKey?.toLowerCase()),
      );
      const merged = [...modifiedData, ...modifiedData2];
      const unique = Array.from(
        new Map(
          merged.map((item) => [item.pmjayRegistrationId, item]),
        ).values(),
      );

      setFilteredReportData(unique);
      setPage(1);
      const startIndex = 0;
      const sliced = unique.slice(startIndex, startIndex + limit);
      setPaginatedData(sliced);
    }
  }, [searchKey, reportData, limit]);

  useEffect(() => {
    const totalItems = filteredReportData?.length || 0;
    setTotalPages(Math.ceil(totalItems / limit) || 1);
    setPage(1);
  }, [filteredReportData, limit]);

  useEffect(() => {
    const startIndex = (page - 1) * limit;
    const sliced = filteredReportData.slice(startIndex, startIndex + limit);
    setPaginatedData(sliced);
  }, [page, limit, filteredReportData]);

  useEffect(() => {
    setLimit(value);
    setPage(1);
  }, [value]);

  useEffect(() => {
    if (startDate && endDate) {
      getMonthlyReport();
    }
  }, [startDate, endDate, claimType]);
  useEffect(() => {
    if (!startDate && !endDate) {
      setStartDate(monthlyCountData?.thisMonth?.startDate);
      setEndDate(monthlyCountData?.thisMonth?.endDate);
    }
  }, [monthlyCountData, startDate, endDate]);
  useEffect(() => {
    getMonthlyReportCount();
  }, []);
  return (
    <div>
      <div
        style={{ color: "rgba(0,0,0,0.5)" }}
        className="text-[11px] 2xl:text-sm leading-[18.27px] -tracking-[3%]"
      >
        Home / Report
      </div>
      <div className=" flex items-center justify-end mt-[24px] 2xl:mt-[30px]">
        <div
          style={{
            background: "rgba(255,255,255,0.5)",
            border: "1px solid #FFFFFF",
          }}
          className="flex justify-between items-center xl:w-[350px] 2xl:w-[500px] px-4 2xl:px-5 py-[12px] 2xl:py-[15px] rounded-full"
        >
          <input
            type="text"
            placeholder="Search Patient name, Beneficiary ID, Registered ID"
            className="w-[80%] text-[12px] 2xl:text-[16px] bg-transparent outline-none border-none"
            onChange={handleSearch}
          />
          <img
            src={SearchIcon}
            alt="search-icon"
            className="h-[14px] w-[18px] 2xl:h-[28px] 2xl:w-[23px]"
          />
        </div>
      </div>
      <div
        id="case-list"
        style={{ background: "rgba(255,255,255,0.5)" }}
        className="p-4 2xl:p-8 mt-4 rounded-[30px]"
      >
        <div className="w-full flex items-center justify-between ">
          <div className="text-[30px] 2xl:text-[50px] leading-[65.26px] -tracking-[0.07em]">
            Revenue Credited
          </div>
          <div className="relative">
            {/* Download Button */}
            <div
              className="flex items-center gap-1 text-white text-sm px-4 py-[14px] bg-[#017C71] rounded-full cursor-pointer"
              onClick={() => {
                setShowDownloadMenu((prev) => !prev);
              }}
            >
              <FileDownloadOutlinedIcon />
              Download Report
              <svg
                width="16"
                height="16"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
                className={`transition-transform duration-200 ${
                  showDownloadMenu ? "rotate-180" : ""
                }`}
              >
                <polyline points="6 9 12 15 18 9" />
              </svg>
            </div>

            {/* Download Dropdown */}
            {showDownloadMenu && (
              <div className="absolute right-0 top-full mt-0 w-full bg-white border border-[#AFAFAF] rounded-b-[10px] rounded-t-none overflow-hidden z-50 shadow-sm">
                <button
                  type="button"
                  onClick={() => {
                    setShowDownloadMenu(false);

                    if (filteredReportData?.length > 0) {
                      generatePdf(filteredReportData);
                    } else {
                      toast.info("No data present to generate pdf.");
                    }
                  }}
                  className="w-full text-left px-4 py-3 text-sm text-[#191919] bg-white hover:bg-[#F8F8F8] border-none"
                >
                  Download PDF
                </button>

                <button
                  type="button"
                  onClick={() => {
                    setShowDownloadMenu(false);

                    if (filteredReportData?.length > 0) {
                      generateExcel(filteredReportData);
                    } else {
                      toast.info("No data present to generate excel.");
                    }
                  }}
                  className="w-full text-left px-4 py-3 text-sm text-[#191919] bg-white hover:bg-[#F8F8F8] border-none"
                >
                  Download Excel
                </button>
              </div>
            )}
          </div>
        </div>
        <div
          style={{
            border: "1px solid #FFFFFF",
          }}
          className="mt-[32px] 2xl:mt-[40px] mb-[24px] 2xl:mb-[30px]"
        />
        <div className="flex items-center justify-between w-full mt-[14px] px-4">
          {/* Month Filter */}
          {/* Month Filter */}
          <div className="flex items-center gap-2">
            <MonthRangeDropdown
              monthlyCountData={monthlyCountData}
              claimType={claimType}
              onChange={({ startDate, endDate, label }) => {
                console.log(
                  label,
                  new Date(startDate).toISOString(),
                  new Date(endDate).toISOString(),
                );
                setStartDate(startDate);
                setEndDate(endDate);
              }}
            />

            <RefreshIcon
              onClick={handleRefresh}
              className="cursor-pointer"
              titleAccess="Refresh"
            />
          </div>

          {/* Claim Type Filters */}
          <div className="flex items-center gap-4">
            <label className="flex items-center gap-1 cursor-pointer">
              <input
                type="radio"
                name="claimType"
                value=""
                checked={claimType === ""}
                onChange={() => setClaimType("")}
              />
              <span className="text-[12px] 2xl:text-sm">All</span>
            </label>

            <label className="flex items-center gap-2 cursor-pointer">
              <input
                type="radio"
                name="claimType"
                value="erroneousClaim"
                checked={claimType === "erroneousClaim"}
                onChange={() => setClaimType("erroneousClaim")}
              />
              <span className="text-[12px] 2xl:text-sm">Erroneous Claim</span>
            </label>

            <label className="flex items-center gap-2 cursor-pointer">
              <input
                type="radio"
                name="claimType"
                value="reprocessClaim"
                checked={claimType === "reprocessClaim"}
                onChange={() => setClaimType("reprocessClaim")}
              />
              <span className="text-[12px] 2xl:text-sm">Reprocess Claim</span>
            </label>

            <label className="flex items-center gap-2 cursor-pointer">
              <input
                type="radio"
                name="claimType"
                value="claimReceived"
                checked={claimType === "claimReceived"}
                onChange={() => setClaimType("claimReceived")}
              />
              <span className="text-[12px] 2xl:text-sm">Revenue Credited</span>
            </label>
          </div>
        </div>

        <div className="bg-[white] p-[24px] 2xl:p-[30px] rounded-[15px] mt-[14px]">
          <div
            className={`grid ${
              claimType === "reprocessClaim"
                ? "grid-cols-[0.5fr_1.2fr_1.2fr_1.2fr_1fr]"
                : claimType === "erroneousClaim"
                  ? "grid-cols-[0.5fr_1.2fr_1.2fr_1.2fr_1fr_1fr_1fr]"
                  : claimType === "claimReceived"
                    ? "grid-cols-[0.5fr_1.2fr_1.2fr_1.2fr_1fr_1fr_0.8fr_1fr]"
                    : "grid-cols-[0.5fr_1.2fr_1.2fr_1.2fr_1fr_1fr_0.8fr_1fr_1fr]"
            } gap-4 text-[12px] 2xl:text-sm font-semibold 2xl:leading-[21.7px] -tracking-[3%]`}
          >
            <div>SNo.</div>

            <div>Patient Name</div>

            <div>Registered ID</div>

            <div>Registered Date</div>

            <div>Claim Initiated</div>

            {claimType !== "reprocessClaim" && <div>Claim Approved</div>}

            {(claimType === "" || claimType === "claimReceived") && (
              <>
                <div>TDS</div>
                <div>Revenue Credited</div>
              </>
            )}

            {(claimType === "" || claimType === "erroneousClaim") && (
              <div>Erroneous Requested</div>
            )}
          </div>

          {loading ? (
            <div className="h-[200px] flex justify-center items-center">
              <CircularProgress />
            </div>
          ) : paginatedData?.length > 0 ? (
            paginatedData?.map((reportItem, idx) => {
              return (
                <div
                  key={idx}
                  style={{
                    background:
                      reportItem.currenthsaStage
                        ?.toLowerCase()
                        ?.includes("approved on tms") ||
                      reportItem.currenthsaStage
                        ?.toLowerCase()
                        ?.includes("claim paid")
                        ? "linear-gradient(90deg, #FFFFFF 0%, #B4FFCF 10.5%, #B4FFCF 88%, #FFFFFF 100%)"
                        : reportItem.currenthsaStage
                              ?.toLowerCase()
                              ?.includes("progress") ||
                            reportItem.currenthsaStage
                              ?.toLowerCase()
                              ?.includes("pending")
                          ? "linear-gradient(90deg, #FFFFFF 0%, rgba(237, 255, 140, 0.5) 13%, rgba(237, 255, 140, 0.5) 85%, #FFFFFF 100%)"
                          : "#FFFFFF",
                  }}
                  className={`grid ${
                    claimType === "reprocessClaim"
                      ? "grid-cols-[0.5fr_1.2fr_1.2fr_1.2fr_1fr]"
                      : claimType === "erroneousClaim"
                        ? "grid-cols-[0.5fr_1.2fr_1.2fr_1.2fr_1fr_1fr_1fr]"
                        : claimType === "claimReceived"
                          ? "grid-cols-[0.5fr_1.2fr_1.2fr_1.2fr_1fr_1fr_0.8fr_1fr]"
                          : "grid-cols-[0.5fr_1.2fr_1.2fr_1.2fr_1fr_1fr_0.8fr_1fr_1fr]"
                  } gap-4 text-[12px] 2xl:text-sm py-1 items-center mt-[8px] 2xl:mt-[10px] first:mt-6 2xl:first:mt-8`}
                >
                  <div>{idx + 1}</div>
                  <div>
                    {reportItem?.patientName || "NA"}
                    {
                      <div className="text-[11px] text-[#00000080] -tracking-[0.03em]">
                        {reportItem?.beneficiaryNo}
                      </div>
                    }
                  </div>
                  <div
                    className="cursor-text select-all text-ellipsis text-nowrap overflow-hidden"
                    title={reportItem?.pmjayRegistrationId}
                    onCopy={(e) => {
                      if (reportItem?.pmjayRegistrationId) {
                        e.preventDefault();
                        e.clipboardData.setData(
                          "text/plain",
                          reportItem.pmjayRegistrationId,
                        );
                      }
                    }}
                  >
                    {reportItem?.pmjayRegistrationId
                      ? reportItem.pmjayRegistrationId
                      : "NA"}
                  </div>

                  <div>
                    {reportItem?.registeredDate
                      ? new Date(reportItem?.registeredDate).toLocaleString(
                          "en-GB",
                          {
                            day: "2-digit",
                            month: "2-digit",
                            year: "numeric",
                            hour: "2-digit",
                            minute: "2-digit",
                            second: "2-digit",
                            hour12: false,
                          },
                        )
                      : "NA"}
                  </div>

                  <div>
                    {claimType === "reprocessClaim"
                      ? reportItem?.reprocessClaimDetails?.claimSubmittedAmount
                        ? `₹ ${reportItem.reprocessClaimDetails.claimSubmittedAmount}`
                        : "NA"
                      : claimType === "erroneousClaim"
                        ? reportItem?.erroneousClaimDetails
                            ?.claimSubmittedAmount
                          ? `₹ ${reportItem.erroneousClaimDetails.claimSubmittedAmount}`
                          : "NA"
                        : reportItem?.reprocessClaimDetails
                              ?.claimSubmittedAmount
                          ? `₹ ${reportItem.reprocessClaimDetails.claimSubmittedAmount}`
                          : reportItem?.erroneousClaimDetails
                                ?.claimSubmittedAmount
                            ? `₹ ${reportItem.erroneousClaimDetails.claimSubmittedAmount}`
                            : reportItem?.claimDetails?.claimInitiatedAmount
                              ? `₹ ${reportItem.claimDetails.claimInitiatedAmount}`
                              : "NA"}
                  </div>

                  {claimType !== "reprocessClaim" && (
                    <div>
                      {claimType === "erroneousClaim"
                        ? reportItem?.erroneousClaimDetails?.claimApprovedAmount
                          ? `₹ ${reportItem.erroneousClaimDetails.claimApprovedAmount}`
                          : "NA"
                        : reportItem?.claimDetails?.claimApprovedAmount
                          ? `₹ ${reportItem.claimDetails.claimApprovedAmount}`
                          : "NA"}
                    </div>
                  )}

                  {(claimType === "" || claimType === "claimReceived") && (
                    <>
                      <div>
                        {reportItem?.claimDetails?.tdsAmount && "₹ "}
                        {reportItem?.claimDetails?.tdsAmount || "NA"}
                      </div>

                      <div>
                        {reportItem?.claimDetails?.claimPaidAmount && "₹ "}
                        {reportItem?.claimDetails?.claimPaidAmount || "NA"}
                      </div>
                    </>
                  )}

                  {(claimType === "" || claimType === "erroneousClaim") && (
                    <div>
                      {reportItem?.erroneousClaimDetails
                        ?.erroneousRequestedAmount
                        ? `₹ ${reportItem.erroneousClaimDetails.erroneousRequestedAmount}`
                        : "NA"}
                    </div>
                  )}
                  {/* <div>
                    {(
                      (reportItem?.claimDetails?.claimApprovedAmount /
                        reportItem?.claimDetails?.claimInitiatedAmount) *
                      100
                    ).toFixed(2)}
                    {" %"}
                  </div> */}
                </div>
              );
            })
          ) : (
            <div className="h-[200px] flex justify-center items-center font-semibold text-xl">
              No Case Data Found
            </div>
          )}

          {filteredReportData?.length > 0 && (
            <div className="flex justify-center mt-[12px] 2xl:mt-[15px]">
              <HospitalCustomPaginaion
                page={page}
                setPage={setPage}
                totalPages={totalPages}
              />
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default RevenueReport;
